<div class="bd-highlight mb-3" data-cy="product-card">
  <div class="d-flex">
    <h3
      class="ms-4 me-auto p-2 bd-highlight rb-details-toggle"
      rbDetailsToggle
      [isOpen]="getProductIsOpen()"
      (isOpenChange)="onProductToggleChange($event)"
      #triggerDetails="rbDetailsToggle"
      data-cy="product-title">
      {{ productOption().name | titlecase }}
    </h3>
    @if (triggerDetails.open) {
      <div class="p-2 bd-highlight">
        <rb-form-input
          class="email-input"
          style="width: 300px"
          name="email"
          label="Add user to {{ group() | titlecase }} {{
            productOption().name
          }} group:"
          [(ngModel)]="mailAddress"
          required
          email
          autocomplete="email"
          data-cy="input-username"
          (keydown.enter)="
            inviteUserWorkflow(mailAddress(), group(), productOption().name)
          "
          placeholder="E-mail">
        </rb-form-input>
      </div>
      <div class="p-2 bd-highlight">
        <button
          class="rb-btn rb-primary rb-ic"
          (click)="
            inviteUserWorkflow(mailAddress(), group(), productOption().name)
          "
          data-cy="invite-user-btn"
          style="height: 48px; text-align: center">
          <i class="rb-ic rb-ic-user-add"></i>
        </button>
      </div>
    }
  </div>
  @if (triggerDetails.open) {
    <div class="row">
      <table
        class="m-table"
        *rbTable="'null'; fixedHeaderWidth: false; maxHeight: 'unset'"
        [rbSort]="{ id: 'displayName', direction: '' }"
        (rbSortChange)="onSortChange($event)">
        <thead>
          <tr>
            <th class="col-sm-3" rb-sort-header="email" scope="col">
              <div class="d-flex align-items-center justify-content-between">
                <span>Mail</span>
                <span class="position-relative">
                  <i
                    class="rb-ic rb-ic-copy clickable"
                    title="Copy all emails for this product"
                    (click)="
                      copyEmailsToClipboard(); $event.stopPropagation()
                    "></i>
                  @if (emailsCopied()) {
                    <span class="copied-tooltip">Copied!</span>
                  }
                </span>
              </div>
            </th>
            <th
              class="col-sm-2"
              rb-sort-header="displayName"
              [start]="'desc'"
              scope="col">
              Name
            </th>
            <th class="col-sm-2" rb-sort-header="role" scope="col">Role</th>
            <th class="col-sm-5" colspan="3" scope="col">
              <div class="d-flex justify-content-between">
                <span class="align-content-center me-4"> Scope </span>

                <rb-form-input
                  class="text searchBar"
                  style="width: 300px"
                  name="searchMember"
                  label="Search member in {{ group() | titlecase }} group:"
                  [(ngModel)]="searchMember"
                  (input)="findData(searchMember())"
                  placeholder="Mail or Name">
                </rb-form-input>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (member of filteredMembers(); track member.userId) {
            <tr>
              <td class="col-sm-3">{{ member.email }}</td>
              <td class="col-sm-2 align-content-center text-wrap">
                <div class="d-flex justify-content-between">
                  <div class="align-content-center">
                    @if (isRKeyPressed()) {
                      <span [rbTooltip]="tooltip" [noFix]="true">{{
                        member.displayName
                      }}</span>
                      <ng-template #tooltip>
                        <div class="tooltip-template" style="max-width: 350px">
                          <div class="text-decoration-underline">
                            Permissions:
                          </div>
                          <div>
                            {{ member.permissions.join(', ') }}
                          </div>
                          <br />
                          <div class="text-decoration-underline">
                            DataFilters:
                          </div>
                          <div>
                            {{ member.datafilters.join(', ') }}
                          </div>
                        </div>
                      </ng-template>
                    } @else {
                      <span>{{ member.displayName }}</span>
                    }
                  </div>
                  <!--                                TODO: do a propert admin check-->
                  @if (isAdminCheck(member)) {
                    <div
                      class="justify-content-center align-content-center ms-2">
                      <i
                        class="rb-ic rb-ic-user-mechanic"
                        style="font-size: 200%"></i>
                    </div>
                  }
                </div>
              </td>
              <td class="col-sm-2">
                <rb-form-multi-select
                  name="role-selection-dropdown"
                  idField="id"
                  labelField="label"
                  [items]="productOption().frontendItems.roles"
                  [ngModel]="member.frontendState.roles"
                  label="Roles"
                  maxHeight="200px"
                  class="m-0"
                  style="width: 250px"
                  (ngModelChange)="onRoleSelectionchange($event, member)"
                  [nothingSelectedLabel]="'-'"
                  data-cy="role-selection-dropdown">
                  <span
                    *rbFormMultiSelectOption="let item"
                    data-cy="dropdown-role-item"
                    >{{ item.label }}
                  </span>
                </rb-form-multi-select>
              </td>
              <td class="col-sm-3">
                <rb-form-multi-select
                  name="scope-selection-dropdown"
                  idField="id"
                  labelField="label"
                  [items]="productOption().frontendItems.scopes"
                  [ngModel]="member.frontendState.scopes"
                  label="Scopes"
                  maxHeight="200px"
                  class="m-0"
                  style="width: 250px"
                  (ngModelChange)="onScopeSelectionchange($event, member)"
                  [nothingSelectedLabel]="'-'"
                  data-cy="scope-selection-dropdown">
                  <span
                    *rbFormMultiSelectOption="let item"
                    data-cy="dropdown-scope-item"
                    >{{ item.label }}
                  </span>
                </rb-form-multi-select>
              </td>
              <td class="col-sm-1 align-content-center">
                <div class="d-flex justify-content-end">
                  <span
                    class="rb-ic rb-ic-calendar-clock clickable"
                    [class.activeColor]="isScopeExpirySet(member)"
                    [appPopoverWithHover]="ScopeExpiryDialog"
                    (popoverOpen)="onScopeExpirePopoverOpen($event, member)"
                    (popoverClosed)="onScopeExpirePopoverClose(member)"></span>
                  <ng-template
                    let-close="close"
                    let-fixed="fixed"
                    #ScopeExpiryDialog>
                    <!-- <app-fixed-aware-content [shown]="shown"> -->
                    @if (fixed) {
                      <div class="">
                        <div class="d-flex justify-content-end">
                          <button class="rb-btn rb-link" (click)="close()">
                            <span class="rb-ic rb-ic-close rb-link"></span>
                          </button>
                        </div>
                        <div class="mx-4 mt-3">
                          <rb-form-date-input
                            name="birthday"
                            label="Expiry date"
                            [options]="{
                              dateFormat: 'd-m-Y',
                              minDate: 'today',
                            }"
                            [(ngModel)]="member.frontendState.scopeExpiryDate"
                            [showClearIcon]="true"
                            required
                            class="flex-grow-1"></rb-form-date-input>
                          <rb-form-multi-select
                            name="scope-selection-dropdown"
                            [items]="member.scopes"
                            label="Scopes"
                            maxHeight="200px"
                            style="width: 250px"
                            [nothingSelectedLabel]="'-'"
                            [(ngModel)]="member.frontendState.scopesExpiry">
                            <span *rbFormMultiSelectOption="let item">
                              {{ item }}
                            </span>
                          </rb-form-multi-select>
                          <div class="d-flex justify-content-end my-3">
                            <button
                              class="rb-btn mx-2"
                              (click)="clearExpiryAndClose(member, close)">
                              <span class="rb-ic rb-ic-broom-cloud-dirt"></span>
                              &nbsp;<span>Clear</span>
                            </button>
                            <button
                              class="rb-btn rb-primary"
                              (click)="saveExpiryAndClose(member, close)">
                              <span class="rb-ic rb-ic-save"></span>
                              &nbsp;<span>Save</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    } @else {
                      <div class="m-2">
                        @if (!isScopeExpirySet(member)) {
                          No scope expiry configured.
                        } @else {
                          <div class="mb-1">
                            Expiry configured for
                            <b>{{
                              getFormatedDate(
                                member.frontendState.scopeExpiryDate!
                              )
                            }}</b
                            >:
                          </div>
                          @for (scope of member.scopesExpiry; track $index) {
                            <span>- {{ scope.scope }}</span
                            ><br />
                          }
                        }
                      </div>
                    }
                  </ng-template>
                </div>
              </td>
              <td class="col-sm-1 align-content-center">
                <div class="d-flex justify-content-end">
                  <button
                    class="btn rb-btn rb-secondary rb-ic btn-disable-cross-out"
                    [disabled]="member.userId == activeUserId()"
                    data-cy="delete-user-btn"
                    (click)="
                      openDialog(
                        removeUserDialog,
                        'middle',
                        member.userId,
                        group(),
                        productOption().name
                      )
                    ">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
                <ng-template #removeUserDialog>
                  <rb-dialog
                    dialogTitle="Remove User"
                    headline="Remove user {{ member.displayName }}"
                    confirmationButtonLabel="Confirm"
                    cancelButtonLabel="Cancel"
                    [alert]="{ type: 'error', errorCode: '' }"
                    data-cy="delete-user-dialog">
                    <p>
                      Are you sure you want to remove
                      <b>{{ member.displayName }}</b> from the group?
                    </p>
                    <p>
                      This action cannot be undone and
                      {{ member.displayName }} will lose all access rights.
                    </p>
                    <p>Please confirm if you wish to proceed.</p>
                  </rb-dialog>
                </ng-template>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
